import { LoginModal as SharedLoginModal, setCookie, EMessageType } from '@sifrovacihra/shared-ui'
import { useAction } from "../../store"
import { AUTH_COOKIE } from "../../utils"

type LoginModalProps = {
    open: boolean
    handleClose: () => void
}

export const LoginModal = ({ open, handleClose }: LoginModalProps) => {
    const { setTokenAction, setInfoMessageAction } = useAction()

    const handleSuccess = (token: string) => {
        setTokenAction(token)
        setInfoMessageAction({ type: EMessageType.SUCCESS, message: 'Přihlášení proběhlo úspěšně.' })
        setCookie({ name: AUTH_COOKIE, value: token })
    }

    return (
        <SharedLoginModal
            visible={open}
            onClose={handleClose}
            onSuccess={handleSuccess}
        />
    )
}
